import { render, staticRenderFns } from "./discountCardLog.vue?vue&type=template&id=4e146831&scoped=true&"
import script from "./discountCardLog.vue?vue&type=script&lang=js&"
export * from "./discountCardLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e146831",
  null
  
)

export default component.exports